// maintain alphabetical order
export const enBrandSafety = {
  AdomainContainsDescription: 'With \'contains\', please add keywords.',
  AdomainExactMatchDescription: 'Adomains will first be checked for an exact match. If the given adomain is plainly formatted, it will be checked against variations of the URL.',
  AllowedCreatives: 'Allowed Creatives',
  AllowList: 'Allow List',
  BlockBidsWithMissingValues: 'Block Bids with missing values',
  BrandSafetyTooltipDayparting: 'Use dayparting to set days of the week and hours when you want ads to run. Adding multiple options will provide extra granularity.',
  BrandSafetyTooltipDaypartingExclude: 'Ads will not deliver during the selected hours and days.',
  BrandSafetyTooltipDaypartingInclude: 'Ads will deliver during the selected hours and days.',
  BrandSafetyEventTrackerRuleTypeDescription: 'Event Trackers will be checked against the domain.',
  BrandSafetyMediafileRuleTypeDescription: 'Enter Mediafile domain (with optional path). Mediafile domains will first be checked for an exact match. If the given mediafile domain is plainly formatted, it will be checked against variations of the URL (i.e. getpublica.com matches with https://getpublica.com/mediafile.mp4, http://getpublica.com/path/to/mediafile.mp4, etc.)',
  BrandSafetySnackbarRuleEachExceptionMustTargetAtLeastOneBidder: 'Each exception must target at least 1 bidder.',
  BrandSafetySnackbarRuleMustTargetAtLeastOne: 'Rule must target at least 1 IAB, Adomain, Mediafile domain, Creative ID, Event Tracker, or Language',
  BrandSafetySnackbarRuleMustTargetAtLeastOneItem: 'Rule must target at least 1 {{item}}',
  BrandSafetyTooltipBlockBidsWithMissingValues: 'Use this option to enable blocking bid responses if IAB Category or Adomain is null or missing. The block list has to be targeting IAB Categories to block bid responses with empty IAB Categories. The block list has to be targeting ADomains to block bid responses with empty Adomains.',
  BrandSafetyTooltipIncludesBidsWithMissingAdomains: 'This includes bids with missing adomains',
  BrandSafetyTooltipLanguage: 'The language rule will only apply on channels where Eléa AI is enabled.',
  BrandSafetyTooltipReviewBlockedCreatives: 'Use this option to enable the creatives being blocked to populate the Creative Review Tab within Brand Safety. It will allow you to view the ad, the creative URL and the associated IAB Category & Adomain in order to decide if you\'d like to confirm the block or allow the ad to run by creating an exception.',
  ClickthroughURL: 'Click-through URL',
  CreativeIDCheckedForExactMatch: 'Creative ID will be checked for an exact match.',
  DetectedByEleaAI: 'Detected by Elea AI',
  IAB10Appliances: 'Appliances',
  IAB10Entertaining: 'Entertaining',
  IAB10EnvironmentalSafety: 'Environmental Safety',
  IAB10Gardening: 'Gardening',
  IAB10HomeAndGarden: 'Home & Garden',
  IAB10HomeRepair: 'Home Repair',
  IAB10HomeTheater: 'Home Theater',
  IAB10InteriorDecorating: 'Interior Decorating',
  IAB10Landscaping: 'Landscaping',
  IAB10RemodelingAndConstruction: 'Remodeling & Construction',
  IAB11Commentary: 'Commentary',
  IAB11Immigration: 'Immigration',
  IAB11LawGovtAndPolitics: 'Law, Gov\'t & Politics',
  IAB11LegalIssues: 'Legal Issues',
  IAB11Politics: 'Politics',
  IAB11USGovernmentResources: 'U.S. Government Resources',
  IAB12InternationalNews: 'International News',
  IAB12LocalNews: 'Local News',
  IAB12NationalNews: 'National News',
  IAB12News: 'News',
  IAB13BeginningInvesting: 'Beginning Investing',
  IAB13CreditDebtAndLoans: 'Credit/Debt & Loans',
  IAB13FinancialNews: 'Financial News',
  IAB13FinancialPlanning: 'Financial Planning',
  IAB13HedgeFund: 'Hedge Fund',
  IAB13Insurance: 'Insurance',
  IAB13Investing: 'Investing',
  IAB13MutualFunds: 'Mutual Funds',
  IAB13Options: 'Options',
  IAB13PersonalFinance: 'Personal Finance',
  IAB13RetirementPlanning: 'Retirement Planning',
  IAB13Stocks: 'Stocks',
  IAB13TaxPlanning: 'Tax Planning',
  IAB14Dating: 'Dating',
  IAB14DivorceSupport: 'Divorce Support',
  IAB14EthnicSpecific: 'Ethnic Specific',
  IAB14GayLife: 'Gay Life',
  IAB14Marriage: 'Marriage',
  IAB14SeniorLiving: 'Senior Living',
  IAB14Society: 'Society',
  IAB14Teens: 'Teens',
  IAB14Weddings: 'Weddings',
  IAB15Astrology: 'Astrology',
  IAB15Biology: 'Biology',
  IAB15Botany: 'Botany',
  IAB15Chemistry: 'Chemistry',
  IAB15Geography: 'Geography',
  IAB15Geology: 'Geology',
  IAB15ParanormalPhenomena: 'Paranormal Phenomena',
  IAB15Physics: 'Physics',
  IAB15Science: 'Science',
  IAB15SpaceAstronomy: 'Space/Astronomy',
  IAB15Weather: 'Weather',
  IAB16Aquariums: 'Aquariums',
  IAB16Birds: 'Birds',
  IAB16Cats: 'Cats',
  IAB16Dogs: 'Dogs',
  IAB16LargeAnimals: 'Large Animals',
  IAB16Pets: 'Pets',
  IAB16Reptiles: 'Reptiles',
  IAB16VeterinaryMedicine: 'Veterinary Medicine',
  IAB17AutoRacing: 'Auto Racing',
  IAB17Baseball: 'Baseball',
  IAB17Bicycling: 'Bicycling',
  IAB17Bodybuilding: 'Bodybuilding',
  IAB17Boxing: 'Boxing',
  IAB17CanoeingKayaking: 'Canoeing/Kayaking',
  IAB17Cheerleading: 'Cheerleading',
  IAB17Climbing: 'Climbing',
  IAB17Cricket: 'Cricket',
  IAB17FigureSkating: 'Figure Skating',
  IAB17FlyFishing: 'Fly Fishing',
  IAB17Football: 'Football',
  IAB17FreshwaterFishing: 'Freshwater Fishing',
  IAB17GameAndFish: 'Game & Fish',
  IAB17Golf: 'Golf',
  IAB17HorseRacing: 'Horse Racing',
  IAB17Horses: 'Horses',
  IAB17HuntingShooting: 'Hunting/Shooting',
  IAB17InlineSkating: 'Inline Skating',
  IAB17MartialArts: 'Martial Arts',
  IAB17MountainBiking: 'Mountain Biking',
  IAB17NASCARRacing: 'NASCAR Racing',
  IAB17Olympics: 'Olympics',
  IAB17Paintball: 'Paintball',
  IAB17PowerAndMotorcycles: 'Power & Motorcycles',
  IAB17ProBasketball: 'Pro Basketball',
  IAB17ProIceHockey: 'Pro Ice Hockey',
  IAB17Rodeo: 'Rodeo',
  IAB17Rugby: 'Rugby',
  IAB17RunningJogging: 'Running/Jogging',
  IAB17Sailing: 'Sailing',
  IAB17SaltwaterFishing: 'Saltwater Fishing',
  IAB17ScubaDiving: 'Scuba Diving',
  IAB17Skateboarding: 'Skateboarding',
  IAB17Skiing: 'Skiing',
  IAB17Snowboarding: 'Snowboarding',
  IAB17Sports: 'Sports',
  IAB17SurfingBodyboarding: 'Surfing/Bodyboarding',
  IAB17Swimming: 'Swimming',
  IAB17TableTennisPingPong: 'Table Tennis/Ping-Pong',
  IAB17Tennis: 'Tennis',
  IAB17Volleyball: 'Volleyball',
  IAB17Walking: 'Walking',
  IAB17WaterskiWakeboard: 'Waterski/Wakeboard',
  IAB17WorldSoccer: 'World Soccer',
  IAB18Accessories: 'Accessories',
  IAB18Beauty: 'Beauty',
  IAB18BodyArt: 'Body Art',
  IAB18Clothing: 'Clothing',
  IAB18Fashion: 'Fashion',
  IAB18Jewelry: 'Jewelry',
  IAB18StyleAndFashion: 'Style & Fashion',
  IAB19Animation: 'Animation',
  IAB19AntivirusSoftware: 'Antivirus Software',
  IAB19CamerasAndCamcorders: 'Cameras & Camcorders',
  IAB19CCPlusPlus: 'C/C++',
  IAB19CellPhones: 'Cell Phones',
  IAB19ComputerCertification: 'Computer Certification',
  IAB19ComputerNetworking: 'Computer Networking',
  IAB19ComputerPeripherals: 'Computer Peripherals',
  IAB19ComputerReviews: 'Computer Reviews',
  IAB19Databases: 'Databases',
  IAB19DataCenters: 'Data Centers',
  IAB19DesktopPublishing: 'Desktop Publishing',
  IAB19DesktopVideo: 'Desktop Video',
  IAB19Email: 'Email',
  IAB19Entertainment: 'Entertainment',
  IAB19GraphicsSoftware: 'Graphics Software',
  IAB19HomeVideoDVD: 'Home Video/DVD',
  IAB19InternetTechnology: 'Internet Technology',
  IAB19Java: 'Java',
  IAB19JavaScript: 'JavaScript',
  IAB19MacSupport: 'Mac Support',
  IAB19MP3MIDI: 'MP3/MIDI',
  IAB19NetConferencing: 'Net Conferencing',
  IAB19NetForBeginners: 'Net for Beginners',
  IAB19NetworkSecurity: 'Network Security',
  IAB19PalmtopsPDAs: 'Palmtops/PDAs',
  IAB19PCSupport: 'PC Support',
  IAB19Portable: 'Portable',
  IAB19SharewareFreeware: 'Shareware/Freeware',
  IAB19TechnologyAndComputing: 'Technology & Computing',
  IAB19ThreeDGraphics: '3-D Graphics',
  IAB19Unix: 'Unix',
  IAB19VisualBasic: 'Visual Basic',
  IAB19WebClipArt: 'Web Clip Art',
  IAB19WebDesignHTML: 'Web Design/HTML',
  IAB19WebSearch: 'Web Search',
  IAB19Windows: 'Windows',
  IAB1ArtsAndEntertainment: 'Arts & Entertainment',
  IAB1BooksAndLiterature: 'Books & Literature',
  IAB1CelebrityFanGossip: 'Celebrity Fan/Gossip',
  IAB1FineArt: 'Fine Art',
  IAB1Humor: 'Humor',
  IAB1Movies: 'Movies',
  IAB1Music: 'Music',
  IAB1Television: 'Television',
  IAB20AdventureTravel: 'Adventure Travel',
  IAB20Africa: 'Africa',
  IAB20AirTravel: 'Air Travel',
  IAB20AustraliaAndNewZealand: 'Australia & New Zealand',
  IAB20BedAndBreakfasts: 'Bed & Breakfasts',
  IAB20BudgetTravel: 'Budget Travel',
  IAB20BusinessTravel: 'Business Travel',
  IAB20ByUSLocale: 'By US Locale',
  IAB20Camping: 'Camping',
  IAB20Canada: 'Canada',
  IAB20Caribbean: 'Caribbean',
  IAB20Cruises: 'Cruises',
  IAB20EasternEurope: 'Eastern Europe',
  IAB20Europe: 'Europe',
  IAB20France: 'France',
  IAB20Greece: 'Greece',
  IAB20HoneymoonsGetaways: 'Honeymoons/Getaways',
  IAB20Hotels: 'Hotels',
  IAB20Italy: 'Italy',
  IAB20Japan: 'Japan',
  IAB20MexicoAndCentralAmerica: 'Mexico & Central America',
  IAB20NationalParks: 'National Parks',
  IAB20SouthAmerica: 'South America',
  IAB20Spas: 'Spas',
  IAB20ThemeParks: 'Theme Parks',
  IAB20Travel: 'Travel',
  IAB20TravelingWithKids: 'Traveling with Kids',
  IAB20UnitedKingdom: 'United Kingdom',
  IAB21Apartments: 'Apartments',
  IAB21Architects: 'Architects',
  IAB21BuyingSellingHomes: 'Buying/Selling Homes',
  IAB21RealEstate: 'Real Estate',
  IAB22Comparison: 'Comparison',
  IAB22ContestsAndFreebies: 'Contests & Freebies',
  IAB22Couponing: 'Couponing',
  IAB22Engines: 'Engines',
  IAB22Shopping: 'Shopping',
  IAB23AlternativeReligions: 'Alternative Religions',
  IAB23AtheismAgnosticism: 'Atheism/Agnosticism',
  IAB23Buddhism: 'Buddhism',
  IAB23Catholicism: 'Catholicism',
  IAB23Christianity: 'Christianity',
  IAB23Hinduism: 'Hinduism',
  IAB23Islam: 'Islam',
  IAB23Judaism: 'Judaism',
  IAB23LatterDaySaints: 'Latter-Day Saints',
  IAB23PaganWiccan: 'Pagan/Wiccan',
  IAB23ReligionAndSpirituality: 'Religion & Spirituality',
  IAB24Uncategorized: 'Uncategorized',
  IAB25ExtremeGraphicExplicitViolence: 'Extreme Graphic/Explicit Violence',
  IAB25HateContent: 'Hate Content',
  IAB25Incentivized: 'Incentivized',
  IAB25NonStandardContent: 'Non-Standard Content',
  IAB25Pornography: 'Pornography',
  IAB25ProfaneContent: 'Profane Content',
  IAB25UnderConstruction: 'Under Construction',
  IAB25UnmoderatedUGC: 'Unmoderated UGC',
  IAB26CopyrightInfringement: 'Copyright Infringement',
  IAB26IllegalContent: 'Illegal Content',
  IAB26IllegalContentSub: 'Illegal Content',
  IAB26SpywareMalware: 'Spyware/Malware',
  IAB26Warez: 'Warez',
  IAB2Automotive: 'Automotive',
  IAB2AutoParts: 'Auto Parts',
  IAB2AutoRepair: 'Auto Repair',
  IAB2BuyingSellingCars: 'Buying/Selling Cars',
  IAB2CarCulture: 'Car Culture',
  IAB2CertifiedPreOwned: 'Certified Pre-Owned',
  IAB2Convertible: 'Convertible',
  IAB2Coupe: 'Coupe',
  IAB2Crossover: 'Crossover',
  IAB2Diesel: 'Diesel',
  IAB2ElectricVehicle: 'Electric Vehicle',
  IAB2Hatchback: 'Hatchback',
  IAB2Hybrid: 'Hybrid',
  IAB2Luxury: 'Luxury',
  IAB2MiniVan: 'MiniVan',
  IAB2Motorcycles: 'Motorcycles',
  IAB2OffRoadVehicles: 'Off-Road Vehicles',
  IAB2PerformanceVehicles: 'Performance Vehicles',
  IAB2Pickup: 'Pickup',
  IAB2RoadSideAssistance: 'Road-Side Assistance',
  IAB2Sedan: 'Sedan',
  IAB2TrucksAndAccessories: 'Trucks & Accessories',
  IAB2VintageCars: 'Vintage Cars',
  IAB2Wagon: 'Wagon',
  IAB3Advertising: 'Advertising',
  IAB3Agriculture: 'Agriculture',
  IAB3BiotechBiomedical: 'Biotech/Biomedical',
  IAB3Business: 'Business',
  IAB3BusinessSoftware: 'Business Software',
  IAB3Construction: 'Construction',
  IAB3Forestry: 'Forestry',
  IAB3Government: 'Government',
  IAB3GreenSolutions: 'Green Solutions',
  IAB3HumanResources: 'Human Resources',
  IAB3Logistics: 'Logistics',
  IAB3Marketing: 'Marketing',
  IAB3Metals: 'Metals',
  IAB4CareerAdvice: 'Career Advice',
  IAB4CareerPlanning: 'Career Planning',
  IAB4Careers: 'Careers',
  IAB4College: 'College',
  IAB4FinancialAid: 'Financial Aid',
  IAB4JobFairs: 'Job Fairs',
  IAB4JobSearch: 'Job Search',
  IAB4Nursing: 'Nursing',
  IAB4ResumeWritingAdvice: 'Resume Writing/Advice',
  IAB4Scholarships: 'Scholarships',
  IAB4Telecommuting: 'Telecommuting',
  IAB4UsMilitary: 'U.S. Military',
  IAB5AdultEducation: 'Adult Education',
  IAB5ArtHistory: 'Art History',
  IAB5CollegeAdministration: 'Colledge Administration',
  IAB5CollegeLife: 'College Life',
  IAB5DistanceLearning: 'Distance Learning',
  IAB5Education: 'Education',
  IAB5EnglishAsSecondLanguage: 'English as a 2nd Language',
  IAB5GraduateSchool: 'Graduate School',
  IAB5Homeschooling: 'Homeschooling',
  IAB5HomeworkStudyTips: 'Homework/Study Tips',
  IAB5KSixEducators: 'K-6 Educators',
  IAB5LanguageLearning: 'Language Learning',
  IAB5PrivateSchool: 'Private School',
  IAB5SevenToTwelveEducation: '7-12 Education',
  IAB5SpecialEducation: 'Special Education',
  IAB5StudyingBusiness: 'Studying Business',
  IAB6Adoption: 'Adoption',
  IAB6BabiesAndToddlers: 'Babies & Toddlers',
  IAB6DaycarePreSchool: 'Daycare/Pre School',
  IAB6Eldercare: 'Eldercare',
  IAB6FamilyAndParenting: 'Family & Parenting',
  IAB6FamilyInternet: 'Family Internet',
  IAB6ParentingKSixKids: 'Parenting - K-6 Kids',
  IAB6ParentingTeens: 'Parenting teens',
  IAB6Pregnancy: 'Pregnancy',
  IAB6SpecialNeedsKids: 'Special Needs Kids',
  IAB7ADD: 'A.D.D.',
  IAB7AIDSHIV: 'AIDS/HIV',
  IAB7Allergies: 'Allergies',
  IAB7AlternativeMedicine: 'Alternative Medicine',
  IAB7Arthritis: 'Arthritis',
  IAB7Asthma: 'Asthma',
  IAB7AutismPDD: 'Autism/PDD',
  IAB7BipolarDisorder: 'Bipolar Disorder',
  IAB7BrainTumor: 'Brain Tumor',
  IAB7Cancer: 'Cancer',
  IAB7Cholesterol: 'Cholesterol',
  IAB7ChronicFatigueSyndrome: 'Chronic Fatigue Syndrome',
  IAB7ChronicPain: 'Chronic Pain',
  IAB7ColdAndFlu: 'Cold & Flu',
  IAB7Deafness: 'Deafness',
  IAB7DentalCare: 'Dental Care',
  IAB7Depression: 'Depression',
  IAB7Dermatology: 'Dermatology',
  IAB7Diabetes: 'Diabetes',
  IAB7Epilepsy: 'Epilepsy',
  IAB7Exercise: 'Exercise',
  IAB7GERDAcidReflux: 'GERD/Acid Reflux',
  IAB7HeadachesMigraines: 'Headaches/Migraines',
  IAB7HealthAndFitness: 'Health & Fitness',
  IAB7HeartDisease: 'Heart Disease',
  IAB7HerbsForHealth: 'Herbs for Health',
  IAB7HolisticHealing: 'Holistic Healing',
  IAB7IBSCrohnsDisease: 'IBS/Crohn\'s Disease',
  IAB7IncestAbuseSupport: 'Incest/Abuse Support',
  IAB7Incontinence: 'Incontinence',
  IAB7Infertility: 'Infertility',
  IAB7MensHealth: 'Men\'s Health',
  IAB7Nutrition: 'Nutrition',
  IAB7Orthopedics: 'Orthopedics',
  IAB7PanicAnxietyDisorders: 'Panic/Anxiety Disorders',
  IAB7Pediatrics: 'Pediatrics',
  IAB7PhysicalTherapy: 'Physical Therapy',
  IAB7PsychologyPsychiatry: 'Psychology/Psychiatry',
  IAB7SeniorHealth: 'Senor Health',
  IAB7Sexuality: 'Sexuality',
  IAB7SleepDisorders: 'Sleep Disorders',
  IAB7SmokingCessation: 'Smoking Cessation',
  IAB7SubstanceAbuse: 'Substance Abuse',
  IAB7ThyroidDisease: 'Thyroid Disease',
  IAB7WeightLoss: 'Weight Loss',
  IAB7WomensHealth: 'Women\'s Health',
  IAB8AmericanCuisine: 'American Cuisine',
  IAB8BarbecuesAndGrilling: 'Barbecues & Grilling',
  IAB8CajunCreole: 'Cajun/Creole',
  IAB8ChineseCuisine: 'Chinese Cuisine',
  IAB8CocktailsBeer: 'Cocktails/Beer',
  IAB8CoffeeTea: 'Coffee/Tea',
  IAB8CuisineSpecific: 'Cuisine-Specific',
  IAB8DessertsAndBaking: 'Desserts & Baking',
  IAB8DiningOut: 'Dining Out',
  IAB8FoodAllergies: 'Food Allergies',
  IAB8FoodAndDrink: 'Food & Drink',
  IAB8FrenchCuisine: 'French Cuisine',
  IAB8HealthLowfatCooking: 'Health/Lowfat Cooking',
  IAB8ItalianCuisine: 'Italian Cuisine',
  IAB8JapaneseCuisine: 'Japanese Cuisine',
  IAB8MexicanCuisine: 'Mexican Cuisine',
  IAB8Vegan: 'Vegan',
  IAB8Vegetarian: 'Vegetarian',
  IAB8Wine: 'Wine',
  IAB9ArtsAndCrafts: 'Arts & Crafts',
  IAB9ArtTechnology: 'Art/Technology',
  IAB9Beadwork: 'Beadwork',
  IAB9Birdwatching: 'Birdwatching',
  IAB9BoardGamesPuzzles: 'Board Games/Puzzles',
  IAB9CandleAndSoapMaking: 'Candle & Soap Making',
  IAB9CardGames: 'Card Games',
  IAB9Chess: 'Chess',
  IAB9Cigars: 'Cigars',
  IAB9Collecting: 'Collecting',
  IAB9ComicBooks: 'Comic Books',
  IAB9DrawingSketching: 'Drawing/Sketching',
  IAB9FreelanceWriting: 'Freelance Writing',
  IAB9Genealogy: 'Genealogy',
  IAB9GettingPublished: 'Getting Published',
  IAB9Guitar: 'Guitar',
  IAB9HobbiesAndInterests: 'Hobbies & Interests',
  IAB9HomeRecording: 'Home Recording',
  IAB9InvestorsAndPatents: 'Investors & Patents',
  IAB9JewelryMaking: 'Jewelry Making',
  IAB9MagicAndIllusion: 'Magic & Illusion',
  IAB9Needlework: 'Needlework',
  IAB9Painting: 'Painting',
  IAB9Photography: 'Photography',
  IAB9Radio: 'Radio',
  IAB9RoleplayingGames: 'Roleplaying Games',
  IAB9SciFiAndFantasy: 'Sci-Fi & Fantasy',
  IAB9Scrapbooking: 'Scrapbooking',
  IAB9Screenwriting: 'Screenwriting',
  IAB9StampsAndCoins: 'Stamps & Coins',
  IAB9VideoAndComputerGames: 'Video & Computer Games',
  IAB9Woodworking: 'Woodworking',
  IABEmpty: 'Empty',
  ManualOverride: 'Manual Override',
  ReviewBlockedCreatives: 'Review Blocked Creatives',
  Rule: 'Rule',
  RuleExceptionName: 'Rule Exception Name',
  RuleTargeting: 'Rule Targeting',
  RuleTargetingDescription: 'Pick which object to apply to the rule and set targeting parameters to reach the desired granularity',
  RuleType: 'Rule Type',
  RuleTypeDescription: 'Define the type of rule and elements to exclude or include',
};